import React from 'react';
import cn from 'classnames';
import stylesParent from '../frame.module.scss';
import { useGetTheme } from '../../../../hooks/useGetTheme';
import PropTypes from 'prop-types';

const TextRow = ({ title, text, isAccent, isLargeMargin }) => {
  const colors = useGetTheme();

  return (
    <div
      className={cn(
        stylesParent.cardTextRow,
        isLargeMargin ? stylesParent.lgMarginBottom : stylesParent.mdMarginBottom,
      )}
    >
      <div className={stylesParent.cardTextRowLabel}>{title}</div>
      <div
        className={stylesParent.cardTextRowValue}
        style={{ color: isAccent ? '#ed1b6c' : colors.text }}
      >
        {text}
      </div>
    </div>
  );
};

TextRow.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  isAccent: PropTypes.bool,
  isLargeMargin: PropTypes.bool,
};

TextRow.defaultProps = {
  isAccent: false,
  isLargeMargin: false,
};

export default TextRow;
